import { css } from 'styled-components';

const mediaPrefersReducedMotion = css`
  @media (prefers-reduced-motion) {
    animation: none !important;
    transition: none !important;
  }
`;

export { mediaPrefersReducedMotion };
//# sourceMappingURL=media-queries.js.map
